import React, { useState } from 'react';
import { KeyboardArrowRight, Close as CloseIcon } from '@material-ui/icons';
import { Box, Button, makeStyles } from '@material-ui/core';

const CustomToggleButton = ({
  selected,
  onChange,
  textOff,
  textOn,
  textHover,
  ...rest
}) => {
  const classes = useStyles();
  const [isHovered, setIsHovered] = useState(false);

  const getIcon = () => {
    if (selected && isHovered) {
      return <CloseIcon fontSize="small" />;
    }
    return <KeyboardArrowRight fontSize="small" />;
  };

  let buttonText;
  if (selected && isHovered) {
    // Si 'textHover' no fue provisto, usa 'textOn' como fallback
    buttonText = textHover || textOn;
  } else if (selected) {
    buttonText = textOn;
  } else {
    buttonText = textOff;
  }

  const buttonClasses = `${classes.customButton} ${
    selected ? classes.selected : ''
  }`;

  return (
    <Box display="flex" justifyContent="center" pb={2}>
      <Button
        variant="outlined"
        onClick={() => onChange(!selected)}
        color="primary"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        className={buttonClasses}
        {...rest}
      >
        {buttonText} {getIcon()}
      </Button>
    </Box>
  );
};

const useStyles = makeStyles(theme => ({
  customButton: {
    minWidth: '130px',
    transition: 'background-color 0.2s ease-in-out, color 0.2s ease-in-out',
    fontSize: 12,
    height: 40
  },
  selected: {
    backgroundColor: theme.palette.primary.main,
    color: 'white',
    '&:hover': {
      backgroundColor: theme.palette.error.main,
      borderColor: theme.palette.error.main
    }
  }
}));

export default CustomToggleButton;
